module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_Orange.5fbb3add.png";